
export const authConf = [
    {
        'name': 'Login',
        'class': 'section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0',
        'container': 'container',
        'row': 'row row-cols-1 row-cols-lg-2 row-cols-xl-3',
    },
    {
        'name': 'Logout',
        'class': 'authentication-forgot d-flex align-items-center justify-content-center',
        'container': 'card forgot-box',
        'row': 'card-body',
    },
    {
        'name': 'Password',
        'class': 'section-authentication-signin d-flex align-items-center justify-content-center my-5 my-lg-0',
        'container': 'container',
        'row': 'row row-cols-1 row-cols-lg-2 row-cols-xl-3'
    }
]